<template>
  <div class="dropdown-filter-date ">
    <button class="btn-regular secondary" @click.stop="toggledDropdown">
      <v-date-picker v-if="customSelected" class="calendar"
        mode='range'
        :popoverVisibility="'focus'"
        :disabled-dates ='disabledDates'
        :theme-styles='themeStyles'
        popover-align="right"
        v-model='myRange'
        :min-date='convertDate(minDate)'
        :attributes='attributes'
        :show-day-popover="false"
        :is-double-paned="true"
        show-caps>
        <input
          class="calendar-base"
          type='text'
          slot-scope='{ inputValue, updateValue }'
          disabled
          :value='inputValue'
          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
          <template scope="">
            <v-btn class="black" @click.native="cancelDate">Cancel</v-btn>
            <v-btn class="black" @click.native="saveDate">Save</v-btn>
          </template>
      </v-date-picker>
      <label v-else class="label" :class="labelClass">{{labelDropdown}}</label>
      <i v-if="isShown" class="icon-chevronup"></i>
      <i v-else class="icon-chevrondown"></i>
    </button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown-filter-date__menu" @click.stop="isShown = true">
        <div class="dropdown-filter-date__menu__wrapper">
          <ul class="dropdown-filter-date__menu__wrapper__sub">
            <li v-for="item in list" :key="item.id" @click.stop="select(item)"
              class="dropdown-filter-date__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
        <template slot="content">
          <div class="dropdown-filter-date__menu" @click.stop="isShown = true">
            <div class="dropdown-filter-date__menu__wrapper">
              <ul class="dropdown-filter-date__menu__wrapper__sub">
                <li v-for="item in list" :key="item.id" @click.stop="select(item)"
                  class="dropdown-filter-date__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
                </li>
              </ul>
            </div>
          </div>
        </template>
      </modal>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import LabelStatus from '@/components/StatusLabel'
import moment from 'moment'
import lib from '@/lib/util'


export default {
  name: 'adx-dropdown-date-filter',
  components: {
    'media': Media,
    'modal': Modal
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    labelButton: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    valueDisplay: {
      required: false
    },
    startDate:{
      type : String,
      required: false
    },
    endDate:{
      type : String,
      required: false
    },
  },
  data() {
    return {
      maxDate: null,
      minDate: null,
      start: null,
      end: null,
      isShown: false,
      isSet: false,
      selected: null,
      labelDropdown: '',
      labelClass: '',
      firstLabelDropdown: '',
      customSelected: false,
      disabledDates: {
        start : null,
        end : null
      },
      myRange: {
        start: null,
        end: null
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 #f0f0f3',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dates: [],
          highlight: {
            backgroundColor: '#ff3b30',
          },
        },
        {
          dates: [],
          dot: {
            backgroundColor: '#ff3b30',
          },
        }
      ]
    }
  },
  watch: {
    myRange() {
      this.start = new Date(moment.utc(this.myRange.start))
      this.end = new Date(moment.utc(this.myRange.end))
      this.$emit('update:startDate', this.start.toString())
      this.$emit('update:endDate', this.end.toString())
      this.displayRange()
    },
    labelButton() {
      this.labelDropdown = this.labelButton
    },
    valueDisplay() {
      if (!this.valueDisplay) {
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
      }
    },
  },
  async created() {
    this.start = this.startDate
    this.end = this.endDate
    this.minDate = this.startDate

    let today = new Date()
    today.setDate(today.getDate() + 1)
    this.disabledDates= {
      start : new Date(today),
      end : null
    },

    await this.displayRange()
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.labelDropdown = this.labelButton
    this.firstLabelDropdown = this.labelButton
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    select(item) {
      this.$emit('selected', item)
      if (this.selected == item.id) {
        this.selected = null
        this.labelDropdown = item.label
        this.labelClass = ''
        this.isSet = false
      } else {
        if(item.value == 'customdate'){
          this.customSelected = true
          this.labelDropdown = ''
          this.$emit('got-focus')
        } else {
          this.customSelected = false
          this.labelDropdown = item.label
        }
        this.labelClass = item.value
        this.selected = item.id
        this.isSet = true
      }
      this.closeDropdown()
    },
    convertDate(value) {
      return new Date(value)
    },
    displayRange(){
      this.myRange.start = new Date(this.start)
      this.myRange.end = new Date(this.end)
      var date = new Date()
      this.attributes[0].dates = []
      this.attributes[0].dates.push(this.myRange.start, this.myRange.end)
      this.attributes[1].dates.push(date)
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
  button.btn-regular{
    display:flex;
  }
  .calendar-base {
    min-width: 210px;
  }
</style>

